import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import CoupleAccent from "@/components/CoupleAccent";

export const Signoff = () => {
  return (
    <section
      data-testid="signoff-section"
      className="relative py-24 sm:py-32 px-6 text-center"
    >
      <CoupleAccent
        src="/couple/hug.png"
        alt="us hugging"
        className="block mx-auto w-44 sm:w-56 mb-8"
        float={{ y: [0, -12, 0], rotate: [-2, 2, -2] }}
        duration={5.5}
      />
      <div className="max-w-2xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="flex flex-col items-center"
        >
          <div className="flex items-center gap-3 text-[#C28080] mb-6">
            <span className="h-px w-14 bg-[#E8D8D8]" />
            <Heart className="w-4 h-4" fill="currentColor" strokeWidth={0} />
            <span className="h-px w-14 bg-[#E8D8D8]" />
          </div>

          <h2 className="font-serif-love italic text-3xl sm:text-4xl text-[#3A2C2C]">
            i love you, eva.
          </h2>
          <p className="font-body-love text-[#7D6B6B] mt-4 max-w-md">
            not the polished, easy version of loving — the real, patient, i'm-not-going-anywhere kind. this website will still be here whenever you need to come back and read it again.
          </p>

          <p className="font-hand text-6xl sm:text-7xl text-[#C28080] mt-10">
            — Nits
          </p>

          <p className="mt-8 text-xs uppercase tracking-[0.35em] text-[#C28080]">
            made only for you
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Signoff;
